import chatMessages from '../contact/messages';

const translations = {
  chat: chatMessages.en,
  navigation: {
    expertise: "Expertise",
    projects: "Projects",
    team: "Team",
    contact: "Contact",
    openMenu: "Open menu",
    closeMenu: "Close menu",
  },
  footer: {
    baseline: "Mobile app developer",
    legalNotice: "Legal notice",
    rights: "All rights reserved",
  },
  common: {
    contactUs: "Contact us",
    encrypted: "encrypted",
    colon: ":",
  },
  home: {
    hero: {
      title: "Mobile app developer",
      text: "CDO Apps is your trusted partner for mobile application design and development. Our expertise combines creativity, innovation and technical excellence.<br />We turn your ideas into high-performance mobile solutions with outstanding user experiences.",
    },
    figures: {
      collaborators: "Team members",
      years: "Years of experience",
      projects: "Completed projects",
    },
    services: {
      title: "Our offers and services",
      subtitle: "Know-how",
      fixedPrice: {
        title: "Fixed price",
        description: "Control your budget from the start with our fixed-price packages. We work from precise specifications to ensure transparency and alignment, with ready-to-use solutions adapted to your needs.",
      },
      timeAndMaterials: {
        title: "Time and materials",
        description: "Full control over the development process. Ideal for complex projects, this model offers maximum flexibility and complete customization.",
      },
      tailored: {
        title: "Custom solution",
        description: "Solutions shaped around your needs. Our tailored approach customizes every aspect of your mobile app to match your requirements precisely.",
      },
    },
    skills: {
      title: "Our skills at your service",
      subtitle: "Expertise",
      question: "Have a project? Let's talk.",
    },
    projects: {
      title: "Our latest projects",
      subtitle: "Projects",
      all: "See all our projects",
    },
    team: {
      title: "Who are we?",
      subtitle: "Behind the scenes",
      text: "We are a team of passionate mobile app development experts. Our mission is to turn your ideas into high-performance mobile solutions with outstanding user experiences. We put our expertise and creativity at your service to design innovative, intuitive and polished applications perfectly suited to your needs.<br /><br />We are developers, designers, project managers, security and performance experts. We work closely with you to ensure your projects succeed from design to delivery. Our tailored approach and full commitment provide high-quality mobile solutions that meet your expectations.",
    },
    testimonials: {
      page: "Show testimonial page {page}",
      title: "They trusted us",
      subtitle: "References",
      quoteOpen: "“",
      quoteClose: "”",
      tayasui: {
        description: "Apps for artists",
        message: "We have worked with several studios over the past 15 years, and CDO Apps has by far been our best experience. Together, we developed leading iOS and Mac applications, always with great attention to detail and impeccable efficiency. They are a talented and highly conscientious team that we wholeheartedly recommend.",
      },
      jbk: {
        description: "Communication agency",
        message: "Organization, listening and precision were at the heart of our collaboration with CDO Apps. Throughout the project, both their technical expertise and their way of working helped us move forward efficiently. Thank you to the whole team and to Clément.",
      },
      jetitnow: {
        description: "Private jet rental",
        message: "CDO Apps met our expectations by proposing a custom solution for our mobile application. Their technical expertise and creativity were major assets in the success of this project.",
      },
    },
  },
  projects: {
    common: {
      description: "Description",
      technologies: "Technologies used",
      website: "Visit the presentation website",
      detailedDescription: "Detailed description",
      role: "CDO Apps' role",
      availableOn: "Available on",
      includes: "{title} includes:",
      previous: "Previous",
      next: "Next",
    },
  },
  team: {
    members: {
      internalTitle: "Our internal team:",
      internalText: "At CDO Apps, we support our clients from the initial idea through to the final product. Our strength lies in a close-knit team able to manage the full mobile app lifecycle while ensuring technical quality and project follow-up.",
      externalTitle: "Our trusted experts:",
      externalText: "To enrich our projects with graphic, visual and sound dimensions, we work with trusted providers. This complementary expertise helps us deliver applications that are performant, intuitive and polished, perfectly suited to your needs.",
    },
  },
  pages: {
    home: {
      title: "Your custom mobile app | CDO Apps",
      description: "CDO Apps is a custom mobile app development studio. We support you from design to publication on the stores.",
    },
    projects: {
      title: "Our projects | CDO Apps",
      description: "CDO Apps is recognized for the quality of its applications. Discover a selection of projects built for clients and for our own products.",
      heading: "Our projects",
      intro: "CDO Apps is recognized for the quality of its applications. We have worked for many clients and have also developed applications for our own account. Here are a few of our projects.",
      ctaTitle: "Have an app idea in mind?",
      ctaText: "We can help you bring it to life. CDO Apps specializes in mobile app development. We support you from design to publication on the stores. Contact us to discuss your project and get a custom quote.",
    },
    team: {
      title: "Team | CDO Apps",
      description: "Meet the CDO Apps team, made up of designers, developers and graphic artists. We work together to create unique, cutting-edge mobile applications.",
      heading: "Team",
      intro: "We primarily work for the people who use what we create. We are designers, developers and graphic artists. Here is the sum of our talents.",
      ctaTitle: "Does your project need one of our skills?",
      ctaText: "Let's work together. CDO Apps is ready to take on the challenge. Contact us to discuss your project and get a custom quote: depending on your needs, we can propose a tailored solution including a development plan, custom design and quality follow-up.",
    },
    contact: {
      title: "Contact us | CDO Apps",
      description: "Do you need a mobile application with a unique design and cutting-edge technology? Contact us, we would be happy to support your project.",
      heading: "Contact",
      intro: "Do you need a mobile application with a unique design and cutting-edge technology?<br />Contact us, we would be happy to support your project.",
      constructionTitle: "Page under construction",
      constructionText: "This page is under construction: a chatbot will soon be available so you can contact us directly from our website.<br /><br />In the meantime, you can send us an email at the following address: {email}.",
    },
    legalNotice: {
      chatbotTitle: "AI assistant and conversation data",
      chatbotText: "The chatbot helps you find a page on our website or prepare an email. Using it is optional: you can email us directly at {email}.<br /><br />Your messages, relevant previous replies and public website content are sent to OpenAI to generate a reply. Please avoid sharing confidential information. The assistant can make mistakes; you can review and edit any draft before sending it yourself from your email app.<br /><br />A session cookie supports the conversation and its protection. History is temporarily kept on our server, expires after two hours of inactivity and is removed at the next cleanup (run hourly) or when you start a new conversation. No history is kept in your browser’s local storage. Technical counters limit abuse and spending; they do not contain conversation text.<br /><br />We disable storage of responses for later retrieval through the OpenAI API. This does not remove any technical retention by the provider: see <a class=\"underline\" href=\"https://developers.openai.com/api/docs/guides/your-data\">OpenAI’s information about data handling</a>.<br /><br />For a question about your data or an access, correction or deletion request, email {email}.",
      title: "Legal notice | CDO Apps",
      description: "Read the legal notice for the CDO Apps website.",
      heading: "Legal notice",
      editorTitle: "Publisher",
      editorText: "CDO Apps is a SARL with share capital of €5,000, registered with the Melun Trade and Companies Register under number 825 071 905 00012.<br />Its registered office is located at 27 rue de Belfort, 77340 Pontault-Combault, France.<br />Intra-community VAT number: FR 88 825 071 905.<br />Email address: {email}.",
      publicationDirectorTitle: "Publication director",
      publicationDirectorText: "Mr. Clément Choquereau",
      hostingTitle: "Hosting provider",
      hostingText: "The website is hosted by OVH, a SAS with share capital of €50,000,000, registered with the Lille Trade and Companies Register under number 424 761 419 00045, whose registered office is located at 2 rue Kellermann, 59100 Roubaix, France.",
      contactTitle: "Contact",
      contactText: "For any question or complaint regarding the website, you can contact our customer service by email at the following address: {email}.",
      intellectualPropertyTitle: "Intellectual property",
      intellectualPropertyText: "All elements of the website, whether visual or audio, including the underlying technology, are protected by copyright, trademarks or patents. They are the exclusive property of CDO Apps.<br />Any user who has a personal website and wishes to place, for personal use, a simple link directly to the homepage of the CDO Apps website must request authorization from CDO Apps. This shall not be considered an implicit affiliation agreement.",
      personalDataTitle: "Personal data",
      personalDataText: "You can browse this website without providing your identity. If you contact us, we use the information you choose to share to handle your request. To request access, correction or deletion, contact {email}. The chatbot’s data handling is detailed below.",
      linksTitle: "Hyperlinks",
      linksText: "The website may contain hyperlinks to other websites. CDO Apps is not responsible for the content of those websites.",
      lawTitle: "Applicable law",
      lawText: "The website is governed by French law.",
    },
    notFound: {
      title: "Page not found | CDO Apps",
      description: "Sorry, the page you are looking for does not exist.",
      heading: "Page not found",
      text: "Sorry, the page you are looking for does not exist.",
    },
  },
  expertise: {
    common: {
      pageCta: "Tell us about your project",
      description: "Description",
      role: "Our role",
      learnMore: "Learn more",
      otherTitle: "Our other areas of expertise",
      otherSubtitle: "Expertise",
      otherQuestion: "Need expertise for your project?",
      stackTitle: "Technical stack",
      processTitle: "Our process",
    },
    mobileApps: {
      title: "Our mobile app expertise | CDO Apps",
      description: "Discover our mobile app expertise. We design intuitive, polished applications perfectly suited to multiple platforms. Contact us to discuss your project and get a custom quote.",
      heading: "Mobile app",
      intro: "CDO Apps excels in high-quality mobile app development. Our creative and experienced team masters the latest technologies to design intuitive, polished applications perfectly suited to multiple platforms, delivering a smooth and engaging user experience.",
      ctaTitle: "Have a mobile app project in mind?",
      ctaText: "We can help you bring your project to life. CDO Apps specializes in mobile app development. We support you from design to publication on the stores. Contact us to discuss your project and get a custom quote.",
      steps: [
        {
          title: "UI/UX Design",
          description: "User experience is central to our work. We design intuitive, ergonomic interfaces to deliver a smooth and pleasant user experience.",
        },
        {
          title: "Development",
          description: "Our experienced development team masters the latest technologies to build performant and reliable mobile applications that closely follow mockups and specifications.",
        },
        {
          title: "Testing",
          description: "Quality is our priority. We run thorough tests to ensure your applications work properly across platforms and conditions.",
        },
        {
          title: "Publication",
          description: "Once your application is ready, we handle publication on the stores (App Store, Google Play) so it can reach as many users as possible.",
        },
      ],
    },
    backend: {
      title: "Our Back End expertise | CDO Apps",
      description: "Discover our Back End expertise. We provide a solid foundation for your applications, from database management to advanced security. Contact us to discuss your project and get a custom quote.",
      heading: "Back end",
      intro: "The strength of an application lies in its infrastructure. With our Back End expertise, we provide a solid foundation for your applications. From efficient database management to advanced security, we optimize performance to guarantee a reliable and secure user experience.",
      ctaTitle: "Does your project need Back End expertise?",
      ctaText: "We can help you design a solid foundation for your applications. Contact us to discuss your project and get a custom quote.",
      steps: [
        {
          title: "Data modeling",
          description: "When performance and security matter, data modeling is a crucial step. We define your database structure to ensure efficient information management.",
        },
        {
          title: "API documentation",
          description: "To make application integration easier, we provide clear and detailed API documentation. This documentation also becomes the base for front-end development.",
        },
        {
          title: "Authentication",
          description: "Security must be a priority. We implement robust authentication systems to protect your data and ensure access is granted only to authorized users.",
        },
        {
          title: "Deployment",
          description: "Once your application is ready, we handle deployment in two phases: a test deployment to verify the application works properly, then a final deployment to make it publicly available.",
        },
      ],
    },
    graphics: {
      title: "Our 3D development expertise | CDO Apps",
      description: "Discover our 3D development expertise. We push the boundaries of innovation by integrating advanced technologies to create interactive simulations and entertaining game experiences. Contact us to discuss your project and get a custom quote.",
      heading: "3D development",
      intro: "Explore new dimensions with CDO Apps' versatile expertise in 3D development, graphics engines and video games. We push the boundaries of innovation by integrating advanced technologies to create interactive simulations and entertaining game experiences.",
      ctaTitle: "Does your project need 3D development?",
      ctaText: "We can help you explore new dimensions with our 3D development expertise. Contact us to discuss your project and get a custom quote.",
      steps: [
        {
          title: "3D export",
          description: "Your 3D assets must be exported in a format compatible with graphics engines. We master the most common file formats and build custom conversion tools to guarantee smooth integration.",
        },
        {
          title: "Graphics engine",
          description: "The graphics engine is the core of your 3D projects. We keep our knowledge of the engines we use up to date to guarantee quality rendering and optimal performance.<br /><br />We also build dedicated engines for specific projects.",
        },
        {
          title: "Gameplay",
          description: "When your project needs interaction, gameplay is a key element. We design innovative, engaging mechanics to deliver a unique and entertaining user experience.",
        },
        {
          title: "Optimization",
          description: "Optimization is essential to strike the best balance between faithful rendering and strong performance. We optimize 3D models, textures and shaders to provide the smoothest possible user experience.",
        },
      ],
    },
    projectManagement: {
      title: "Our project management expertise | CDO Apps",
      description: "Discover our project management expertise. Every successful project relies on effective management. Our project management expertise ensures transparent coordination from concept to delivery. Contact us to discuss your project and get a custom quote.",
      heading: "Project management",
      intro: "Every successful project relies on effective management.<br />Our project management expertise ensures transparent coordination from concept to delivery. We maintain constant communication to guarantee your projects are completed successfully.",
      ctaTitle: "Do you need effective project management?",
      ctaText: "We can help you coordinate and manage your projects transparently. Contact us to discuss your project and get a custom quote.",
      steps: [
        {
          title: "Specifications",
          description: "The first step in any project is defining specifications. We work closely with you to define your needs and objectives, and to establish detailed requirements.",
        },
        {
          title: "Planning",
          description: "Careful planning is essential to any project's success. We establish a precise and detailed schedule to ensure efficient coordination and meet deadlines.",
        },
        {
          title: "Tracking",
          description: "We use secure tools to manage source code and project versions: each change is tracked and documented, maintaining a complete history of changes.<br /><br />At the same time, we keep you continuously informed about project progress.",
        },
        {
          title: "Delivery",
          description: "Once the project is complete, we deliver it within the agreed timeline. We also provide a warranty period so you can validate your project under real conditions according to the criteria defined during specifications.",
        },
      ],
    },
  },
};

export default translations;
